import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators , FormControl } from '@angular/forms';
import { AuthService } from '../_service/auth.service';
import { AlertifyService } from '../_service/alertify.service';
import { ContactUsService } from '../_service/contactUs.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'contact',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})

export class ContactUsComponent implements OnInit {
  contactUs: ContactUsInterface = {
    fullName: '',
    emailAddress: '',
    healthAuthority: '',
    facility: '',
    phoneNumber: '',
    subject: '',
    message: '',
    recaptchaToken: ''
  };

  model: any = {};
  selectedSearchParameter = 'General Question';
  contactUsForm: FormGroup;
  name: string = '';
  emailAddress: string = '';
  healthAuthority: string = '';
  facility: string = '';
  phoneNumber: string = '';
  subject: string = '';
  message: string = '';
  loading = false;
  recaptchaValid = false;
  
  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    private alertify: AlertifyService,
    private contactUsService: ContactUsService
  ) 
  { 
    this.contactUsForm = fb.group({
      fullNameFormControl : new FormControl('', [
        Validators.required,
        Validators.maxLength(125),
        this.WhitespaceValidator
      ]),
      phoneNumberFormControl : new FormControl('', [
        Validators.required,
        Validators.maxLength(20),
        this.WhitespaceValidator,
      ]),
      messageFormControl : new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
        this.WhitespaceValidator
      ]),
      emailFormControl : new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
      ])
    });
  }

  subjectFormControl = new FormControl('', [
    Validators.required,
  ]);

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

  onSelectSubject(event) {

    if (event.value === 'General Question') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'Product Information') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'Account Information') {
      this.selectedSearchParameter = event.value;
    }
    if (event.value === 'Other') {
      this.selectedSearchParameter = event.value;
    }
  }

  resetForm() {
    this.selectedSearchParameter = 'General Question';
    this.contactUsForm.reset();
    this.subjectFormControl.reset(this.selectedSearchParameter);
    this.recaptchaValid = false;
    this.contactUs.recaptchaToken = '';
    
    // Reset reCAPTCHA
    if (typeof (window as any).grecaptcha !== 'undefined') {
      (window as any).grecaptcha.reset();
    }
  }

  ngOnInit() {
    this.waitForRecaptchaAndRender();
  }

  waitForRecaptchaAndRender() {
    if (typeof (window as any).grecaptcha !== 'undefined' && (window as any).grecaptcha.render) {
      this.renderRecaptcha();
    } else {
      setTimeout(() => this.waitForRecaptchaAndRender(), 100);
    }
  }

  renderRecaptcha() {
    (window as any).grecaptcha.render('recaptcha_field', {
      'sitekey': environment.recaptchaSiteKey,
      'callback': (response: string) => this.onRecaptchaSuccess(response),
      'expired-callback': () => this.onRecaptchaExpired(),
      'error-callback': () => this.onRecaptchaError()
    });
  }

  onRecaptchaSuccess(token: string) {
    this.contactUs.recaptchaToken = token;
    this.recaptchaValid = true;
  }

  onRecaptchaExpired() {
    this.contactUs.recaptchaToken = '';
    this.recaptchaValid = false;
  }

  onRecaptchaError() {
    this.contactUs.recaptchaToken = '';
    this.recaptchaValid = false;
  }

  contactUsFunction() {
    this.loading = true;
    this.contactUs.fullName = this.contactUsForm.get('fullNameFormControl').value.trim();
    this.contactUs.emailAddress = this.contactUsForm.get('emailFormControl').value.trim();
    this.contactUs.phoneNumber = this.contactUsForm.get('phoneNumberFormControl').value.trim();
    this.contactUs.subject = this.selectedSearchParameter.trim();

    if (this.contactUsForm.controls.messageFormControl.value === null) {
      this.contactUs.message = 'N/A';
    } else {
      this.contactUs.message = this.contactUsForm.get('messageFormControl').value;
    }

    return this.contactUsService.contactUsForm(this.contactUs).subscribe(res => {
      this.loading = false;
      this.alertify.success('Thank you for contacting us! Your email was successfully sent.');
      this.resetForm();
    },
    error => {
      this.loading = false;
      this.alertify.error('Something went wrong. Please try again!');
    });
  }
}

export class ContactUsInterface {
  fullName: string;
  emailAddress: string;
  healthAuthority: string;
  facility: string;
  phoneNumber: string;
  subject: string;
  message: string;
  recaptchaToken: string;
}